module.exports = __webpack_public_path__ + "img/charge-icon.2c505d24.png";